import { LocalAgentNodeClient } from './local-agent-node-client'

let localAgentNodeClientSingleton: LocalAgentNodeClient | null = null

export function getLocalAgentNodeClient(): LocalAgentNodeClient {
  if (!localAgentNodeClientSingleton) {
    localAgentNodeClientSingleton = new LocalAgentNodeClient()
  }

  return localAgentNodeClientSingleton
}
